import React from "react"
import CountryCard from "./CountryCard"
import {
    Container,
    Col,
    Row
  } from 'reactstrap';

function CompareCountry(){
    return(
        <Container>
            <Row>
                <h3>How does your country compare?</h3>
            </Row>
            <Row>
                <Col sm="6">
                    <CountryCard/>    
                </Col>
                <Col sm="6">
                    <CountryCard/>
                </Col>
            </Row>
        </Container>
    )
}
export default CompareCountry